import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const BrandBriefPopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "BrandBriefPopup" */ './Container'),
  'popup'
);
